<template>
  <div class="sv-action-col-menu">
    <v-menu :open-on-hover="openOnHover">
      <template #activator="{ on }">
        <div class="sv-action-col-menu__activator">
          <slot name="activator" :on="on" v-bind="activatorBinds">
            <v-icon v-bind="activatorBinds" v-on="{ ...on, ...$listeners }">
              {{ icon }}
            </v-icon>
          </slot>
        </div>
      </template>

      <v-list
        class="sv-action-col-menu__list"
        :color="listColor"
        :dense="dense"
      >
        <slot />
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import "./ActionColMenu.scss";
import { computed } from "vue";

export default {
  props: {
    color: {
      type: String,
      default: "primary"
    },
    listColor: {
      type: String,
      default: null
    },
    small: Boolean,
    disabled: Boolean,
    loading: Boolean,
    openOnHover: Boolean,
    dense: Boolean,
    icon: {
      type: String,
      default: "mdi-dots-vertical"
    }
  },
  setup(props) {
    const activatorBinds = computed(() => {
      return {
        small: props.small,
        loading: props.loading,
        disabled: props.disabled,
        color: props.color
      };
    });

    return { activatorBinds };
  }
};
</script>
